import { useEffect, useState, useCallback , useRef } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import InputMask from 'react-input-mask';
import { GinecologiaRecord } from './GinecologiaRecord';
import Webcam from "react-webcam";
import moment from "moment"

const modeloDatos = {
    pacienteID:0,
    empresaid: 0
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , seguroiD: 0
    , poliza: ''
    , direccion: ''
    , ago_Mtp: ''
    , prs: ''
    , parejas: 0
    , fur: ''
    , fup: ''
    , resultado: ''
    , app: ''
    , apf: ''
    , toxicos: ''
    , qx: ''
    , espec_Vaginal: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''


}

const Ginecologia = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListadoSeg, SetListadoSeg] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [Camara, SetCamara] = useState(false);

    const [Inicio, SetInicio] = useState(false);

    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;
       
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                item.nombres 
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };


    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
   
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Pacientes/ListaPacientes/1");
        if (response.ok) {
            let data = await response.json()
            SetListado1(data);
            setPendiente(false)
            if (Inicio == false) {
                SetListado(data);
                SetInicio(true);
            }

        }
    }

    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "Mantenimiento/ListaSeguros" + "/" + correo );
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }


    useEffect(() => {
        obtenerDatos();
        obtenerDatosSeg();
    }, [tabla])

    const abrirRecord = (data) => {
        Setpaciente(data);
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.pacienteID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Pacientes/GuardarPacientes", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Pacientes/EditarPacientes", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
            obtenerDatos();
            Swal.fire(
                'Paciente Guardado!',
            
                'success'
            )
       
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.pacienteID,
            sortable: true,
        },
        {
            name: 'Pacientes ',
            selector: row => row.nombres +" "+ row.apellidos ,
            sortable: true,
        },
        {
            name: 'Telefono ',
            selector: row => row.telefono,
            sortable: true,
        }, {
            name: 'Seguro ',
            selector: row => row.seguroID,
            sortable: true,
        },


       
        {
            name: '',
            cell: row => (
                <>
                    <Button class="btn" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirRecord(row)}
                    >
                        <i className="fas fa-eye"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    const videoConstraints = {
        width: 20,
        height: 20,
        facingMode: "user"
    };
    const webcamRef = useRef(null);
    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            SetCamara(false)
        
            tabla.imagen = imageSrc;
            document.getElementsByName("imagen").value = imageSrc;
        },
        [webcamRef]
  
    );

    return (
        <>

            <div hidden={paciente.length == 0} >
              
                    <h4> Informaciones del Paciente.</h4>
                <hr style={{ border: '1px solid', margin:'1px' }} />
                <Row>

                    <Col md="1" style={{'margin-right': '40px'} } >
                        <FormGroup >
                    <img  src={paciente.imagen} height={130} width={140} />
                        </FormGroup>
                </Col>
                    <Col md="4">
                        <FormGroup >
                            <b>NOMBRES Y APELLIDOS: </b>{paciente.nombres}
                        </FormGroup>
             
                        <FormGroup>
                             <b>EDAD:</b>     {Moment(paciente.fechaNacimiento).format("DD/MM/YYYY")}
                        </FormGroup>
                        <FormGroup>
                            <b>ARS: </b>     {paciente.seguroID}
                        </FormGroup>
                        <FormGroup>
                            <b>MOVIL:</b>      {paciente.celular} 
                        </FormGroup>

                        <FormGroup>
                            <b>POLIZA: </b>    {paciente.poliza} 
                        </FormGroup>
                        </Col>
                        <Col md="3">
                        <FormGroup>
                            <b>PRS:</b>     {paciente.prs} 
                        </FormGroup>
                        <FormGroup>
                            <b> PAREJAS:</b>      {paciente.parejas}
                        </FormGroup>
                        <FormGroup>
                            <b>FUR: </b>      {paciente.fur},
                        </FormGroup>
                        <FormGroup>
                             <b>FUP:</b>     {paciente.fup}
                        </FormGroup>
                        <FormGroup>
                            <b>AGO/MTP: </b>    {paciente.ago_Mtp} 
                        </FormGroup>

                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <b>APP: </b>     {paciente.app}
                        </FormGroup>
                        <FormGroup>
                            <b>PF:</b>       {paciente.pf} 
                        </FormGroup>
                        <FormGroup>
                             <b>TOXICOS: </b>    {paciente.toxicos}
                        </FormGroup>
                        <FormGroup>

                            <b> RESULTADOS: </b>      {paciente.resultado} 

                        </FormGroup>
                         </Col>
                </Row>
              
           


            </div>
            <Row>
                <Col md="6" hidden={paciente.length == 0} >
                    <div hidden={paciente.length == 0} ><GinecologiaRecord data={paciente} /></div> 

            </Col>
            <Col md="6" >
                <Card>
                        <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                            <Row>
                     <Col md="8" >  
                        <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de paciente " ></Input></Col>

                                <Col md="4" >
                                   
                                    <Button color="success" size="md"
                                onClick={() => setVerModal(!verModal)}
                            ><b>Nuevo Paciente</b></Button></Col></Row>
                    </CardHeader>
                    <CardBody>
                      
                        <DataTable
                            columns={columns}
                            data={Listado}
                            progressPending={pendiente}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}
                          

                        />
                    </CardBody>
                </Card>
            </Col>
            </Row>
        

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader>
                    Mantenimiento de Pacientes
                </ModalHeader>
                <ModalBody>


                    <Row>
                       
                                    <Col md="4">
                                        <FormGroup >
                                             <Label for="exampleEmail">Cedula</Label>

                                <InputMask type="text" mask="999-9999999-9" name="cedula" id="Cedula"
                                    placeholder="Cedula" onChange={handleChange} value={tabla.cedula} className="form-control" />
                           
                                           </FormGroup>
                                        </Col>
                     
                        <Col md="4"> 
                                        <FormGroup >
                                           <Label for="exampleEmail">Nombres</Label>
                                <Input type="text" name="nombres" id="Nombres" value={tabla.nombres}
                                    placeholder="Nombres" onChange={handleChange} />
                            </FormGroup>
                        </Col>

                        <Col md="4">
                            <FormGroup >
                                                <Label for="exampleEmail">Apellidos</Label>
                                <Input bsSize="sm" name="apellidos" id="Apellidos" value={tabla.apellidos}
                                                    placeholder="Apellidos" onChange={handleChange} />   
                                        </FormGroup></Col>
                        <Col md="4">
                            <FormGroup >
                                <Label for="exampleEmail">Telefono</Label>
                                <InputMask type="text" mask="999-999-9999" value={tabla.telefono} className="form-control" name="telefono" id="Telefono"
                                    placeholder="Telefono" onChange={handleChange} />
                            </FormGroup></Col>
                                     <Col md="4"> 
                                        <FormGroup >
                                            <Label for="exampleEmail">Celular</Label>
                                <InputMask mask="999-999-9999" className="form-control" type="text" name="celular" id="Celular" value={tabla.celular}
                                                    placeholder="Celular" onChange={handleChange} />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup >
                                <Label for="exampleEmail">FechaNacimiento</Label>
                                <Input type="date" name="fechaNacimiento" id="FechaNacimiento" value={ Moment(tabla.fechaNacimiento).format('YYYY-MM-DD')}
                                    placeholder="FechaNacimiento" onChange={handleChange} />
                            </FormGroup>
                        </Col>
                        <Col md="4">   <FormGroup >  <Label for="exampleEmail">Sexo</Label>
                            <Input type="select" name="sexo" id="Sexo" value={tabla.sexo} onChange={handleChange}>
                                <option value={0 }>FEMENINO</option>
                                <option value={1}>MASCULINO</option>
                                <option value={2} >OTRO</option>

                                                </Input>
                                          
                                        </FormGroup>  </Col>

 <Col md="4">
                                        <FormGroup >
                                             <Label for="exampleEmail">SeguroID</Label>
                                <Input type="select" name="seguroID" value={tabla.seguroID} onChange={handleChange}>
                                    {ListadoSeg.map(x => <option value={x.seguroID}> {x.descripcion}</option>)}
                                </Input>
                            </FormGroup>
                        </Col>
                                            <Col md="4">
                                                <Label for="exampleEmail">Poliza</Label>
                            <Input type="text" name="poliza" value={tabla.poliza} id="Poliza"
                                    placeholder="Poliza" onChange={handleChange} />   </Col>


                        <Col md="6">  <FormGroup > <Label for="exampleEmail">Direccion</Label>
                            <Input type="text" name="direccion" value={tabla.direccion} id="Direccion"
                                                    placeholder="Direccion" onChange={handleChange} />
                                          
                                        </FormGroup>  </Col>

                                     
                                            <Col md="2">   <FormGroup >

                                                <Label for="exampleEmail">Ago_Mtp</Label>
                            <Input type="text" name="ago_Mtp" value={tabla.ago_Mtp} id="Ago_Mtp"
                                                    placeholder="Ago_Mtp" onChange={handleChange} />      </FormGroup> </Col>
                        <Col md="2">
                            <FormGroup >
                                                <Label for="exampleEmail">App</Label>
                                <Input type="text" name="app" id="App" value={tabla.app}
                                                    placeholder="App" onChange={handleChange} />   

                                        </FormGroup></Col>

                                        
                                            <Col md="2"> <FormGroup > <Label for="exampleEmail">Prs</Label>
                            <Input type="text" name="prs" id="Prs" value={tabla.prs}
                                                    placeholder="Prs" onChange={handleChange} />
                                           </FormGroup>  </Col>
                        <Col md="3"><FormGroup >
                                                <Label for="exampleEmail">Parejas</Label>
                            <Input type="number" name="parejas" value={tabla.parejas} id="Parejas"
                                placeholder="Parejas" onChange={handleChange} />  </FormGroup>  </Col>
                        <Col md="3"> <FormGroup > <Label for="exampleEmail">Fur</Label>
                            <Input type="text" name="fur" id="Fur" value={tabla.fur}
                                                    placeholder="Fur" onChange={handleChange} />
                        </FormGroup>  </Col>
                        <Col md="3"><FormGroup >
                                                <Label for="exampleEmail">Fup</Label>
                            <Input type="text" name="fup" id="Fup" value={tabla.fup}
                                                    placeholder="Fup" onChange={handleChange} />  
                        </FormGroup> </Col>

                      


                                            <Col md="3">   <FormGroup > <Label for="exampleEmail">Apf</Label>
                            <Input type="text" name="apf" id="Apf" value={tabla.apf}
                                                    placeholder="Apf" onChange={handleChange} />
                        </FormGroup>  </Col>
                        <Col md="3"> <FormGroup >
                                                <Label for="exampleEmail">Toxicos</Label>
                            <Input type="text" name="toxicos" id="Toxicos" value={tabla.toxicos}
                                placeholder="Toxicos" onChange={handleChange} />  </FormGroup>  </Col>
                        <Col md="3"> <FormGroup > <Label for="exampleEmail">Qx</Label>
                            <Input type="text" name="qx" id="Qx" value={tabla.qx}
                                                    placeholder="Qx" onChange={handleChange} />
                                            </FormGroup>    </Col>
                                    
                                    

                                            <Col md="3">    <FormGroup >
                                                <Label for="exampleEmail">Espec_Vaginal</Label>
                            <Input type="text" name="espec_Vaginal" id="Espec_Vaginal" value={tabla.espec_Vaginal}
                                placeholder="Espec_Vaginal" onChange={handleChange} />  </FormGroup>   </Col>

                        <Col md="3"> <FormGroup >  <Label for="exampleEmail">Resultado</Label>
                            <Input type="text" name="resultado" id="Resultado" value={tabla.resultado}
                                                    placeholder="Resultado" onChange={handleChange} />
                        </FormGroup>  </Col>
                                     
                                        <FormGroup >

                            <Col md="6" hidden>  <Label for="exampleEmail">Imagen</Label>
                                <Input hidden={true} type="text" name="imagen" id="Imagen" value={tabla.imagen}
                                    placeholder="Imagen"  />
                                <button hidden={Camara} class="btn btn-lg" onClick={() => SetCamara(true)}><i class="fa fa-camera" aria-hidden="true"></i></button>
                                <img hidden={Camara} src={tabla.imagen} height={200} width={200} />
                              
                            </Col>
                          
                                        </FormGroup>
                                        
                 
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={Camara}>
                <ModalHeader>
                  TOMAR FOTO
                </ModalHeader>
                <ModalBody>
                    <div >
                        <Webcam
                            audio={false}
                            height={400}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={400}
                            videoConstraints={videoConstraints}
                        />
                        <button onClick={capture}>Tomar Foto</button>

                    </div>
                </ModalBody>
                <ModalFooter>
         
                    <Button size="sm" color="danger"
                        onClick={()=>SetCamara(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
    )

}
export default Ginecologia;